import { render, staticRenderFns } from "./PrintTagsIndex.vue?vue&type=template&id=698eb4c2"
import script from "./PrintTagsIndex.vue?vue&type=script&lang=js"
export * from "./PrintTagsIndex.vue?vue&type=script&lang=js"
import style0 from "./PrintTagsIndex.vue?vue&type=style&index=0&id=698eb4c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports